var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoyalty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20.0 20.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "loyalty_i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,0 L420,1738 L0,1738 L0,0 L420,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "loyalty_i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C9.55,0 10.05,0.22 10.41,0.58 L19.41,9.58 C19.77,9.94 20,10.45 20,11 C20,11.55 19.78,12.05 19.41,12.41 L12.41,19.41 C12.05,19.78 11.55,20 11,20 C10.45,20 9.95,19.78 9.59,19.42 L0.59,10.42 C0.22,10.05 0,9.55 0,9 L0,2 C0,0.9 0.9,0 2,0 Z M13.5,9 C12.81,9 12.18,9.28 11.73,9.73 L11,10.46 L10.27,9.74 C9.82,9.28 9.19,9 8.5,9 C7.12,9 6,10.12 6,11.5 C6,12.19 6.28,12.81 6.73,13.27 L11,17.54 L15.27,13.27 C15.72,12.82 16,12.19 16,11.5 C16,10.12 14.88,9 13.5,9 Z M3.5,2 C2.67,2 2,2.67 2,3.5 C2,4.33 2.67,5 3.5,5 C4.33,5 5,4.33 5,3.5 C5,2.67 4.33,2 3.5,2 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-230.0 -150.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#loyalty_i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.9999999999986 148.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.0 2.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#loyalty_i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 20,0 20,20 0,20 0,0",
    stroke: "none",
    fill: "currentColor"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyalty);
export default __webpack_public_path__ + "static/media/loyalty.38a649867eee71a23d24eceb4fb2e791.svg";
export { ForwardRef as ReactComponent };